import styled from "styled-components"
import { useState, useEffect, useRef } from 'react'

import type { TUpload } from "../types"

import { development, isSnap } from "../constants"

import { filesUpload } from '../Services'

import dzIcon from '../../assets/upload-icon.svg'
import './DropZone.css'


const Wrapper = styled.div<{ dragOver: boolean }>`
    background: ${props => props.dragOver ? "rgba(239, 253, 255, 0.8)" : "rgb(255, 255, 255)"};`
const DropScreen = styled.div<{
    dragOver: boolean,
}>`
    position: ${development ? 'absolute' : 'fixed'};

    z-index: ${props => props.dragOver ? '10' : '0'};
`
const Content = styled.div<{
    dragOver: boolean,
}>`
    visibility: ${props => props.dragOver ? 'hidden' : 'visible'};
`

const DropZoneBackground = styled.div<{
    dragOver: boolean,
}>`
    visibility: ${props => props.dragOver ? 'visible' : 'hidden'};
    opacity: ${props => props.dragOver ? '1' : '0'};
`

const DropZoneIcon = styled.img``

const DropZoneDescription = styled.div``

const TitleIcon = styled.img``

const Title = styled.h2``

const Description = styled.p``

const BrowseFiles = styled.button``

const Warning = styled.div``


const DropZone = ({
    title,
    description,
    buttonText,
    warning,
    upload,
}: {
    title: string,
    description: string,
    buttonText: string,
    warning: string,

    upload: TUpload,
}) => {
    const ref = useRef<HTMLInputElement>(null)
    const [dragOver, setDragOver] = useState(false)
    const [disableButton, setDisableButton] = useState(true)
    const accept = upload.allowExtantions.map(e => `.${e}`).join(', ')

    useEffect(() => {
        setDisableButton(false)
    })

    return (
        <Wrapper className="dz-wrapper" dragOver={dragOver}>
            <DropScreen
                className="dz-drop-screen"
                onDrop={(e) => {
                    e.preventDefault()
                    setDragOver(false)
                    upload.clearErrors()
                    
                    filesUpload({
                        files: e.dataTransfer.files,
                        upload: upload,
                    })
                }}
                onDragOver={(e) => {
                    e.preventDefault()
                    setDragOver(true)
                }}
                onDragLeave={() => {
                    setDragOver(false)
                }}
                dragOver={dragOver}
            />

                <Content className="dz-content" dragOver={dragOver}>
                    <TitleIcon
                        width="66"
                        height="48"
                        className="dz-title-icon"
                        src={dzIcon}
                        alt="Upload Icon"
                    />
                    <Title className="dz-title">{title}</Title>
                    <Description className="dz-title-description">{description}</Description>
                    <BrowseFiles
                        className="dz-browse-files"
                        onClick={() => {
                            if (ref?.current) ref.current.click()
                        }}
                        disabled={isSnap || disableButton}
                    >{buttonText}</BrowseFiles>
                    <Warning className="dz-warning">{warning}</Warning>
                    <input
                        type="file"
                        accept={accept}
                        ref={ref}
                        style={{ display: 'none' }}
                        multiple={upload.multiselect}
                        onChange={(e) => {
                            const files = e.target.files
                            if (files !== null) {
                                upload.clearErrors()
                                filesUpload({
                                    files: files,
                                    upload: upload,
                                })
                            }
                            e.target.value = ''
                        }}
                    />
                </Content>

                <DropZoneBackground className="dz-background" dragOver={dragOver}>
                    <DropZoneIcon
                        loading="lazy"
                        width="66"
                        height="48"
                        className="dz-icon"
                        src={dzIcon}
                        alt="Upload Icon"
                    />
                    <DropZoneDescription className="dz-description">Drag and drop you files here</DropZoneDescription>
                </DropZoneBackground>
                
        </Wrapper>
    )
}

export default DropZone